export const topbarFilterInputs = {
  scenario1: {
    selectedObject: {
      country: '50004',
      outcome_variable: 'clean_fuel',
      outcome_variable_obj: {},
      outcome_variables: {},
      circumstances_labels: {},
      scheme_details: [
        {
          scheme: '70001',
          age: [0, 18],
          benefit_percent: 4,
          benefit_currency: 0,
          benefit_ppp: 0,
          admin_cost: 5,
          pmt: false,
          is_selected: true
        },
        {
          scheme: '70003',
          age: [65, 100],
          benefit_percent: 16,
          benefit_currency: 0,
          benefit_ppp: 0,
          admin_cost: 5,
          pmt: false,
          pt: false,
          is_selected: true
        },
        {
          scheme: '70002',
          age: [0, 100],
          benefit_percent: 14,
          benefit_currency: 0,
          benefit_ppp: 0,
          admin_cost: 5,
          pmt: false,
          is_selected: true
        }
      ]
    },
    modeStatus: {
      70001: {
        editMode: {
          age: false,
          benefit_percent: false,
          admin_cost: false,
          pmt: false
        },
        collapseMode: {
          age: false,
          benefit_percent: false,
          admin_cost: false,
          pmt: false
        },
        toggleMode: {
          pmt: false
        }
      },
      70002: {
        editMode: {
          age: false,
          benefit_percent: false,
          admin_cost: false,
          pmt: false
        },
        collapseMode: {
          age: false,
          benefit_percent: false,
          admin_cost: false,
          pmt: false
        },
        toggleMode: {
          pmt: false
        }
      },
      70003: {
        editMode: {
          age: false,
          benefit_percent: false,
          admin_cost: false,
          pmt: false,
          pt: false
        },
        collapseMode: {
          age: false,
          benefit_percent: false,
          admin_cost: false,
          pmt: false,
          pt: false
        },
        toggleMode: {
          pmt: false,
          pt: false
        }
      },
      70004: {
        editMode: {
          // age: false,
          week: false,
          benefit_percent: false,
          // benefit_currency: false,
          admin_cost: false,
          pmt: false
        },
        collapseMode: {
          // age: false,
          week: false,
          benefit_percent: false,
          // benefit_currency: false,
          admin_cost: false,
          pmt: false
        },
        toggleMode: {
          pmt: false
        }
      }
    },
    countryFilters: [
      {
        id: 'scenario1_country',
        label: 'Scenario A:',
        key: 'country',
        items: [
          { value: '50004', label: 'Cambodia' },
          { value: '50011', label: 'Maldives' }
        ],
        class: '',
        no_border: true
      }
    ],
    outcomeFilters: [
      {
        id: 'scenario1_outcome_variable',
        label: 'Outcome Variable:',
        key: 'outcome_variable',
        items: [
          { value: 'clean_fuel', label: 'Clean Fuel' }
        ],
        class: '',
        no_border: true
      }
    ],
    filters: [
      {
        id: 'scenario1_scheme_detail',
        label: 'Select benefit programme(s):',
        type: 'checkbox_detail',
        key: 'scheme_details',
        items: [
          {
            value: '70001',
            label: 'Child',
            tip_sections: [
              {
                name: 'benefit_percent',
                order: 1,
                title: 'Benefit level (% of GDP per capita)',
                title_back: 'Benefit level ([[currency]])',
                editable: true,
                edit_type: 'benefit_currency',
                edit_title: 'in [[currency]]',
                edit_title_back: 'in % of GDP per capita',
                benefit_info: 'This is equivalent to <b>$[[ppp]] PPP</b>, or <b>[[currency]] [[benefit_currency]]</b> per month.',
                benefit_info_back: 'This is equivalent to <b>$[[ppp]] PPP</b>, or <b>[[benefit_percent]]%</b> of GDP per capita per annum.',
                info: 'The transfer value is paid monthly per child, in local currency. Globally, yearly child benefit on average is 4% GDP per capita.',
                type: 'slider',
                slider_settings: {
                  min: 0,
                  max: 16,
                  interval: 1,
                  marks: {
                    0: 0,
                    2: 2,
                    4: {
                      label: 4,
                      style: {
                        display: 'block',
                        width: '16px',
                        height: '32px',
                        background: 'url(/themes/custom/tbdtheme/assets/dist/img/icons/up_mark_stroke.svg) bottom no-repeat, url(/themes/custom/tbdtheme/assets/dist/img/icons/down_mark_fill.svg) top no-repeat',
                        transform: 'translate(-5px, -14px)',
                        borderRadius: '0'
                      }
                    },
                    6: 6,
                    8: 8,
                    10: 10,
                    12: 12,
                    14: 14,
                    16: 16
                  }
                },
                shortcut_marks: [
                  {
                    name: 'Global Average',
                    thumbnail: '/themes/custom/tbdtheme/assets/dist/img/icons/up_mark_stroke.svg',
                    value: 4
                  },
                  {
                    name: 'OECD Average',
                    thumbnail: '/themes/custom/tbdtheme/assets/dist/img/icons/down_mark_fill.svg',
                    value: 4
                  }
                ]
              },
              {
                name: 'pmt',
                order: 4,
                title: 'Mean Targeting',
                is_hide_in_comparative: true,
                editable: false,
                type: 'toggle',
                toggleable: true,
                toggle_text: 'PMT (programme means-tested) Targeting'
              }
            ]
          },
          {
            value: '70002',
            label: 'Disability',
            tip_sections: [
              {
                name: 'benefit_percent',
                order: 1,
                title: 'Benefit level (% of GDP per capita)',
                title_back: 'Benefit level ([[currency]])',
                editable: true,
                edit_type: 'benefit_currency',
                edit_title: 'in [[currency]]',
                edit_title_back: 'in % of GDP per capita',
                benefit_info: 'This is equivalent to <b>$[[ppp]] PPP</b>, or <b>[[currency]] [[benefit_currency]]</b> per month.',
                benefit_info_back: 'This is equivalent to <b>$[[ppp]] PPP</b>, or <b>[[benefit_percent]]%</b> of GDP per capita per annum.',
                info: 'The transfer value is paid monthly per eligible person, in local currency. Globally, yearly disability benefit on average is 14% of GDP per capita, while among OECD countries it is on average 23%',
                type: 'slider',
                slider_settings: {
                  min: 0,
                  max: 60,
                  interval: 1,
                  marks: {
                    0: 0,
                    10: 10,
                    14: {
                      label: '',
                      style: {
                        display: 'block',
                        width: '16px',
                        height: '14px',
                        background: 'white',
                        backgroundRepeat: 'no-repeat',
                        backgroundImage: 'url(/themes/custom/tbdtheme/assets/dist/img/icons/up_mark_stroke.svg)',
                        transform: 'translate(-5px, 4px)',
                        borderRadius: '0'
                      }
                    },
                    20: 20,
                    23: {
                      label: '',
                      style: {
                        display: 'block',
                        width: '16px',
                        height: '14px',
                        background: 'white',
                        backgroundRepeat: 'no-repeat',
                        backgroundImage: 'url(/themes/custom/tbdtheme/assets/dist/img/icons/down_mark_fill.svg)',
                        transform: 'translate(-5px, -14px)',
                        borderRadius: '0'
                      }
                    },
                    30: 30,
                    40: 40,
                    50: 50,
                    60: 60
                  }
                },
                shortcut_marks: [
                  {
                    name: 'Global Average',
                    thumbnail: '/themes/custom/tbdtheme/assets/dist/img/icons/up_mark_stroke.svg',
                    value: 14
                  },
                  {
                    name: 'OECD Average',
                    thumbnail: '/themes/custom/tbdtheme/assets/dist/img/icons/down_mark_fill.svg',
                    value: 23
                  }
                ]
              },
              {
                name: 'pmt',
                order: 4,
                title: 'Mean Targeting',
                is_hide_in_comparative: true,
                editable: false,
                type: 'toggle',
                toggleable: true,
                toggle_text: 'PMT (programme means-tested) Targeting'
              }
            ]
          },
          {
            value: '70003',
            label: 'Old Age',
            tip_sections: [
              {
                name: 'benefit_percent',
                order: 1,
                title: 'Benefit level (% of GDP per capita)',
                title_back: 'Benefit level ([[currency]])',
                editable: true,
                edit_type: 'benefit_currency',
                edit_title: 'in [[currency]]',
                edit_title_back: 'in % of GDP per capita',
                benefit_info: 'This is equivalent to <b>$[[ppp]] PPP</b>, or <b>[[currency]] [[benefit_currency]]</b> per month.',
                benefit_info_back: 'This is equivalent to <b>$[[ppp]] PPP</b>, or <b>[[benefit_percent]]%</b> of GDP per capita per annum.',
                info: 'The transfer value is paid monthly per eligible person, in local currency. Globally, yearly old age benefit on average is 16% of GDP per capita, while among OECD countries it is on an average 22%',
                type: 'slider',
                slider_settings: {
                  min: 0,
                  max: 60,
                  interval: 1,
                  value: 16,
                  marks: {
                    0: 0,
                    10: 10,
                    16: {
                      label: '',
                      style: {
                        display: 'block',
                        width: '16px',
                        height: '14px',
                        background: 'white',
                        backgroundRepeat: 'no-repeat',
                        backgroundImage: 'url(/themes/custom/tbdtheme/assets/dist/img/icons/up_mark_stroke.svg)',
                        transform: 'translate(-5px, 4px)',
                        borderRadius: '0'
                      }
                    },
                    20: 20,
                    22: {
                      label: '',
                      style: {
                        display: 'block',
                        width: '16px',
                        height: '14px',
                        background: 'white',
                        backgroundRepeat: 'no-repeat',
                        backgroundImage: 'url(/themes/custom/tbdtheme/assets/dist/img/icons/down_mark_fill.svg)',
                        transform: 'translate(-5px, -14px)',
                        borderRadius: '0'
                      }
                    },
                    30: 30,
                    40: 40,
                    50: 50,
                    60: 60
                  }
                },
                shortcut_marks: [
                  {
                    name: 'Global Average',
                    thumbnail: '/themes/custom/tbdtheme/assets/dist/img/icons/up_mark_stroke.svg',
                    value: 16
                  },
                  {
                    name: 'OECD Average',
                    thumbnail: '/themes/custom/tbdtheme/assets/dist/img/icons/down_mark_fill.svg',
                    value: 22
                  }
                ]
              },
              {
                name: 'pmt',
                order: 4,
                title: 'Mean Targeting',
                is_hide_in_comparative: true,
                editable: false,
                type: 'toggle',
                toggleable: true,
                toggle_text: 'PMT (programme means-tested) Targeting'
              }
            ]
          }
        ]
      }
    ]
  }
};
